export default "<style>\r\n \r\n\r\n</style>";